import React, { Fragment } from 'react';
import { PieChart, Pie, ResponsiveContainer } from 'recharts';
import { Card, CardBody, Col } from 'reactstrap';
import TagOutlineIcon from 'mdi-react/BankOutlineIcon';
import PropTypes from 'prop-types';
import moment from "moment"; 
import {
  Link
} from "react-router-dom";
import{
	_capitalizeText,
	_getBuildingURL,
} from '../../../../../shared/helpers/utils';
import { getDefaultChartColors } from '../../../../../shared/helpers';
import ToolTip from '../../../../../shared/components/ToolTip';

const calculateBarData = (statsRes, buildingRes) => {	
	
	let totalOriginal = statsRes.corp_owner && statsRes.corp_owner.count ? statsRes.corp_owner && statsRes.corp_owner.count : 0;
	
	const buildingTotal = buildingRes.inventory_total || buildingRes.total_units_sellable || buildingRes.total_units_residential || buildingRes.residential_units || buildingRes.total_units || 0;
	const totalAvail = buildingTotal > totalOriginal ? buildingTotal - totalOriginal : 0;
	return [{ value: totalOriginal, fill: '#00b5cc' },
  				{ value: totalAvail, fill: '#DBE0E8' }];
}

const CardPercent = ( { link, statsRes, data } ) => {
	
	return (<CardBody className={`${link ? 'chart__link' : ''} dashboard__health-chart-card`} style={{ padding:10, borderRadius:0 }}  >
	    	<div className="card__title">
	          <h5 className="card__title-center">{`% Corporate`}
			  	<ToolTip title={"Percent of owners who used a corporate entity (LLC, Corp, etc) to purchase the unit."} />
			  </h5>
	        </div>
	        <div className="dashboard__health-chart"> 
	          <ResponsiveContainer height={144}>
	            <PieChart>
	              <Pie data={data} dataKey="value" cy={58} innerRadius={54} outerRadius={63} />
	
	            </PieChart>
	          </ResponsiveContainer>
	          <div className="pie-chart-info">
	            <TagOutlineIcon style={{ fill: '#00b5cc' }} />
	            <h5 className="profile__chart-number">{statsRes !== false ? (data[0].value > 0 ? parseFloat((data[0].value / (data[0].value + (data[1].value ? data[1].value : 0)) * 100) ).toFixed(0) + '%' : '0%') : '--'}</h5>
	            <div className="product-card__subtext">corporate</div>
	          </div>
	          <div className="product-card__subtext">{statsRes !== false ? `(${data[0].value > 0 ? data[0].value : '0'} owners)` : '--'}</div>
	        </div>
		</CardBody>);
};

const OriginalOwner = (props) => {
	const { buildingRes, statsRes, col } = props;
	const data = calculateBarData(statsRes, buildingRes);
	
	
	return (
		  <Col md={12} xl={col ? col : 3} lg={6} sm={12} xs={12}>		  	
		    <Card>
		    {props.location ? 
			    <Link to={`${props.location.pathname.replace('/tab/overview', '')}/tab/units?owner=corporate`}>
				    <CardPercent data={data} statsRes={statsRes} buildingRes={buildingRes} link />
				</Link>
			:
				<CardPercent data={data} statsRes={statsRes} buildingRes={buildingRes} />
			}
			</Card>
		  </Col>
    )
};



export default OriginalOwner;
